import React from 'react'

const CustomLoader = () => {
  return (
    <div>CustomLoader</div>
  )
}

export default CustomLoader